import { createSlice } from '@reduxjs/toolkit';

import { fetchProviderFilters } from './actions';

import type { ProviderFiltersState } from './types';

const initialState: ProviderFiltersState = {
  data: null,
  isFetching: false,
  error: null,
};

export const providerFiltersSlice = createSlice({
  name: 'providerFilters',
  initialState,
  reducers: {
    setProviderFilters(state, action) {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProviderFilters.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchProviderFilters.fulfilled, (state, action) => {
        state.isFetching = false;
        state.data = action.payload;
      })
      .addCase(fetchProviderFilters.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.error?.message ?? 'Failed to fetch provider filters';
      });
  },
});

export const { setProviderFilters } = providerFiltersSlice.actions;
export const providerFiltersReducer = providerFiltersSlice.reducer;
